/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  Box,
  Button,
  TextField,
  MenuItem,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import PeopleIcon from "@material-ui/icons/People";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import EditIcon from "@material-ui/icons/Edit";
import PrintIcon from "@material-ui/icons/Print";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import CancelIcon from "@material-ui/icons/Cancel";
import TableChartIcon from "@material-ui/icons/TableChart";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import DescriptionIcon from "@material-ui/icons/Description";

import { SalaryService } from "_services/salary.service";
import SalaryPersonDetailModal from "./SalaryPersonDetailModal";
import SalaryBatchCategoryManager from "./SalaryBatchCategoryManager";
import SalaryEmployeeManager from "./SalaryEmployeeManager";
import SalarySlipDialog from "./SalarySlipDialog";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    fontFamily: '"Sarabun", "Tahoma", sans-serif'
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2)
  },
  title: {
    fontWeight: "bold",
    color: "#0d47a1",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    backgroundColor: "#fbfbfb",
    border: "1px solid #e0e0e0"
  },
  kpiCard: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(2),
    borderLeft: "5px solid transparent"
  },
  kpiEmployees: { borderLeftColor: "#1976d2" },
  kpiIncomes: { borderLeftColor: "#2e7d32" },
  kpiOutcomes: { borderLeftColor: "#c62828" },
  kpiNet: { borderLeftColor: "#00897b" },
  kpiStatus: { borderLeftColor: "#f57c00" },
  tabRoot: {
    borderBottom: "1px solid #e0e0e0",
    marginBottom: theme.spacing(2),
    backgroundColor: "#fff"
  },
  tableHeader: {
    backgroundColor: "#eceff1",
    fontWeight: "bold"
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: "#fafafa"
    },
    "&:hover": {
      backgroundColor: "#f0f4f8"
    }
  }
}));

const thaiMonths = [
  { val: 1, name: "มกราคม" },
  { val: 2, name: "กุมภาพันธ์" },
  { val: 3, name: "มีนาคม" },
  { val: 4, name: "เมษายน" },
  { val: 5, name: "พฤษภาคม" },
  { val: 6, name: "มิถุนายน" },
  { val: 7, name: "กรกฎาคม" },
  { val: 8, name: "สิงหาคม" },
  { val: 9, name: "กันยายน" },
  { val: 10, name: "ตุลาคม" },
  { val: 11, name: "พฤศจิกายน" },
  { val: 12, name: "ธันวาคม" }
];

export default function SalaryView() {
  const classes = useStyles();

  // Current user & Finance permission check
  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  // ระบบ Salary ใช้ isFinance ที่ set depKey เฉพาะ 157 เท่านั้น
  const isFinanceUser = (() => {
    if (!currentUser) return false;
    const userDepts = Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];

    const isFinance = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 157;
    });

    const isAdmin =
      currentUser?.roles?.includes("Admin") ||
      currentUser?.userName === "madarakung" ||
      userDepts.some(u => Number(u.departmentKey) === 108);

    return isFinance || isAdmin;
  })();

  // Current year in BE (e.g. 2026 + 543 = 2569)
  const currentYearBE = new Date().getFullYear() + 543;
  const currentMonth = new Date().getMonth() + 1;

  const [calYear, setCalYear] = useState(currentYearBE);
  const [calMonth, setCalMonth] = useState(currentMonth);
  const [typeGov, setTypeGov] = useState(0);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState(0);

  // Data states
  const [loading, setLoading] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [banks, setBanks] = useState([]);
  const [incomes, setIncomes] = useState([]);
  const [outcomes, setOutcomes] = useState([]);

  // Modals & Dialogs
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedUserForDetail, setSelectedUserForDetail] = useState(null);
  const [slipDialogOpen, setSlipDialogOpen] = useState(false);
  const [selectedUserForSlip, setSelectedUserForSlip] = useState(null);

  // Rollover Dialog
  const [rolloverDialogOpen, setRolloverDialogOpen] = useState(false);
  const [targetYear, setTargetYear] = useState(currentYearBE);
  const [targetMonth, setTargetMonth] = useState(currentMonth === 12 ? 1 : currentMonth + 1);
  const [rollingOver, setRollingOver] = useState(false);

  // Available Years
  const years = [
    currentYearBE + 1,
    currentYearBE,
    currentYearBE - 1,
    currentYearBE - 2,
    currentYearBE - 3,
    2566,
    2565,
    2564,
    2563
  ];

  // Types of Government Personnel (Loaded from table typegov via API)
  const [typeGovList, setTypeGovList] = useState([]);

  useEffect(() => {
    if (isFinanceUser) {
      loadMasterData();
    }
  }, [isFinanceUser]);

  useEffect(() => {
    if (isFinanceUser && calYear && calMonth) {
      loadMonthlySummary();
    }
  }, [isFinanceUser, calYear, calMonth, typeGov]);

  const loadMasterData = async () => {
    try {
      const res = await SalaryService.getMasterData();
      if (res.data && res.data.success && res.data.data) {
        setBanks(res.data.data.banks || []);
        setIncomes(res.data.data.incomes || []);
        setOutcomes(res.data.data.outcomes || []);
        if (Array.isArray(res.data.data.typeGovList) && res.data.data.typeGovList.length > 0) {
          setTypeGovList(
            res.data.data.typeGovList.map(t => ({
              key: t.typeGovKey || t.TypeGovKey || t.key,
              name: t.name || t.Name,
              code: t.code || t.Code
            }))
          );
        }
      }
    } catch (err) {
      console.error("Error loading master data:", err);
    }

    try {
      const tgRes = await SalaryService.getTypeGov();
      const rawData = tgRes.data?.data || (Array.isArray(tgRes.data) ? tgRes.data : []);
      if (Array.isArray(rawData) && rawData.length > 0) {
        setTypeGovList(
          rawData.map(t => ({
            key: t.typeGovKey || t.TypeGovKey || t.key,
            name: t.name || t.Name,
            code: t.code || t.Code
          }))
        );
      }
    } catch (tgErr) {
      console.error("Error loading typeGov list:", tgErr);
    }
  };

  const loadMonthlySummary = async () => {
    setLoading(true);
    try {
      const res = await SalaryService.getMonthlySummary(
        calYear,
        calMonth,
        typeGov,
        search
      );
      if (res.data && res.data.success && res.data.data) {
        setSummaryData(res.data.data);
      }
    } catch (err) {
      console.error("Error loading monthly summary:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleBatchConfirm = async approveStatus => {
    const actionText = approveStatus === "y" ? "อนุมัติข้อมูลเงินเดือนทั้งหมด" : "ยกเลิกการอนุมัติทั้งหมด";
    if (!window.confirm(`ต้องการ "${actionText}" ประจำเดือน ${calMonth}/${calYear} ใช่หรือไม่?`)) {
      return;
    }

    try {
      const res = await SalaryService.batchConfirmMonth({
        calYear,
        calMonth,
        typeGov,
        approve: approveStatus
      });
      if (res.data && res.data.success) {
        alert(res.data.message);
        loadMonthlySummary();
      } else {
        alert(res.data?.message || "เกิดข้อผิดพลาดในการดำเนินการ");
      }
    } catch (err) {
      console.error("Error confirming month:", err);
      alert("เกิดข้อผิดพลาดในการอนุมัติข้อมูล");
    }
  };

  const handleRollover = async () => {
    setRollingOver(true);
    try {
      const res = await SalaryService.rolloverMonth({
        sourceCalYear: calYear,
        sourceCalMonth: calMonth,
        targetCalYear: targetYear,
        targetCalMonth: targetMonth,
        typeGov
      });
      if (res.data && res.data.success) {
        alert(res.data.message);
        setRolloverDialogOpen(false);
        // Switch to target view
        setCalYear(targetYear);
        setCalMonth(targetMonth);
      } else {
        alert(res.data?.message || "เกิดข้อผิดพลาดในการยกยอด");
      }
    } catch (err) {
      console.error("Error rolling over salary:", err);
      alert("เกิดข้อผิดพลาดในการยกยอด");
    } finally {
      setRollingOver(false);
    }
  };

  const filteredItems = (summaryData?.items || []).filter(item => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      item.fullName.toLowerCase().includes(s) ||
      item.userName.toLowerCase().includes(s) ||
      (item.positionName && item.positionName.toLowerCase().includes(s)) ||
      (item.identificationID && item.identificationID.includes(s)) ||
      (item.accountNo && item.accountNo.includes(s))
    );
  });

  if (!isFinanceUser) {
    return (
      <div className={classes.root}>
        <Paper style={{ padding: 48, textAlign: "center", backgroundColor: "#fff", borderRadius: 8 }}>
          <MonetizationOnIcon style={{ fontSize: 64, color: "#f59e0b", marginBottom: 16 }} />
          <Typography variant="h5" style={{ fontWeight: "bold", color: "#1e293b" }} gutterBottom>
            ขออภัย คุณไม่มีสิทธิ์เข้าถึงระบบบริหารจัดการเงินเดือน
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ maxWidth: 600, margin: "0 auto 24px auto" }}>
            ระบบนี้สงวนสิทธิ์เฉพาะเจ้าหน้าที่กลุ่มงานการเงินและบัญชีเท่านั้น หากต้องการตรวจสอบข้อมูลสลิปเงินเดือนของท่าน สามารถไปยังหน้าสลิปเงินเดือนได้
          </Typography>
          <Button
            variant="contained"
            color="primary"
            href="/finance/slip"
            startIcon={<DescriptionIcon />}
            style={{ backgroundColor: "#2563eb", borderRadius: 6 }}
          >
            ไปยังหน้าสลิปเงินเดือนของฉัน
          </Button>
        </Paper>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {/* Top Header */}
      <div className={classes.header}>
        <div>
          <Typography variant="h5" className={classes.title}>
            <MonetizationOnIcon fontSize="large" /> ระบบบริหารจัดการเงินเดือนและค่าตอบแทน (Salary)
          </Typography>
          <Typography variant="body2" color="textSecondary">
            จัดการข้อมูลเงินเดือน, รายการได้, รายการหัก, บัญชีธนาคาร และพิมพ์สลิปเงินเดือน
          </Typography>
        </div>

        {/* Action Buttons */}
        <Box display="flex" gap={1} flexWrap="wrap">
          <Button
            variant="contained"
            color="primary"
            startIcon={<DoneAllIcon />}
            onClick={() => handleBatchConfirm("y")}
            disabled={loading || !summaryData?.items?.length}
          >
            อนุมัติทั้งเดือน
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<CancelIcon />}
            onClick={() => handleBatchConfirm("n")}
            disabled={loading || !summaryData?.items?.length}
          >
            ยกเลิกอนุมัติ
          </Button>
          <Button
            variant="outlined"
            style={{ color: "#00796b", borderColor: "#00796b" }}
            startIcon={<ArrowForwardIcon />}
            onClick={() => setRolloverDialogOpen(true)}
            disabled={loading}
          >
            ยกยอดไปเดือนถัดไป
          </Button>
        </Box>
      </div>

      {/* Filter Toolbar Card */}
      <Card variant="outlined" className={classes.filterCard}>
        <CardContent style={{ padding: "12px 16px" }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} sm={2}>
              <TextField
                select
                fullWidth
                size="small"
                variant="outlined"
                label="ปี พ.ศ."
                value={calYear}
                onChange={e => setCalYear(Number(e.target.value))}
              >
                {years.map(y => (
                  <MenuItem key={y} value={y}>
                    พ.ศ. {y}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={6} sm={2}>
              <TextField
                select
                fullWidth
                size="small"
                variant="outlined"
                label="ประจำเดือน"
                value={calMonth}
                onChange={e => setCalMonth(Number(e.target.value))}
              >
                {thaiMonths.map(m => (
                  <MenuItem key={m.val} value={m.val}>
                    {m.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                select
                fullWidth
                size="small"
                variant="outlined"
                label="กลุ่มบุคลากร"
                value={typeGov}
                onChange={e => setTypeGov(Number(e.target.value))}
              >
                <MenuItem value={0}>ทั้งหมดทุกกลุ่ม</MenuItem>
                {typeGovList.map(t => (
                  <MenuItem key={t.key} value={t.key}>
                    {t.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="ค้นหาชื่อ, ตำแหน่ง, เลขบัญชี, บัตรประชาชน..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>

            <Grid item xs={12} sm={1} style={{ textAlign: "right" }}>
              <Button
                variant="outlined"
                size="medium"
                startIcon={<RefreshIcon />}
                onClick={loadMonthlySummary}
                disabled={loading}
              >
                รีเฟรช
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* KPI Stat Cards */}
      <Grid container spacing={2} style={{ marginBottom: 24 }}>
        <Grid item xs={12} sm={6} md={2}>
          <Card className={`${classes.kpiCard} ${classes.kpiEmployees}`}>
            <Typography variant="caption" color="textSecondary">
              จำนวนบุคลากร
            </Typography>
            <Typography variant="h5" style={{ fontWeight: "bold", color: "#1976d2" }}>
              {summaryData?.totalEmployees || 0} คน
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={`${classes.kpiCard} ${classes.kpiIncomes}`}>
            <Typography variant="caption" color="textSecondary">
              รวมรายได้ทั้งหมด (Gross)
            </Typography>
            <Typography variant="h5" style={{ fontWeight: "bold", color: "#2e7d32" }}>
              {(summaryData?.totalIncomeAll || 0).toLocaleString("th-TH", {
                minimumFractionDigits: 2
              })}{" "}
              บาท
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={`${classes.kpiCard} ${classes.kpiOutcomes}`}>
            <Typography variant="caption" color="textSecondary">
              รวมรายการหักทั้งหมด (Deductions)
            </Typography>
            <Typography variant="h5" style={{ fontWeight: "bold", color: "#c62828" }}>
              {(summaryData?.totalOutcomeAll || 0).toLocaleString("th-TH", {
                minimumFractionDigits: 2
              })}{" "}
              บาท
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Card className={`${classes.kpiCard} ${classes.kpiNet}`}>
            <Typography variant="caption" color="textSecondary">
              ยอดจ่ายสุทธิ (Net Payable)
            </Typography>
            <Typography variant="h5" style={{ fontWeight: "bold", color: "#00897b" }}>
              {(summaryData?.totalNetAll || 0).toLocaleString("th-TH", {
                minimumFractionDigits: 2
              })}{" "}
              บาท
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Card className={`${classes.kpiCard} ${classes.kpiStatus}`}>
            <Typography variant="caption" color="textSecondary">
              สถานะการอนุมัติ
            </Typography>
            <Box mt={0.5}>
              {summaryData?.allApproved ? (
                <Chip
                  icon={<CheckCircleIcon />}
                  label="อนุมัติครบทุกคนแล้ว"
                  size="small"
                  style={{ backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: "bold" }}
                />
              ) : (
                <Chip
                  icon={<HourglassEmptyIcon />}
                  label="มีรายการรออนุมัติ"
                  size="small"
                  style={{ backgroundColor: "#fff3e0", color: "#e65100", fontWeight: "bold" }}
                />
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={(e, val) => setActiveTab(val)}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabRoot}
      >
        <Tab icon={<TableChartIcon />} label="สรุปเงินเดือนประจำเดือน" />
        <Tab icon={<PlaylistAddCheckIcon />} label="บันทึกตามหมวดรายรับ-รายจ่าย" />
        <Tab icon={<CreditCardIcon />} label="จัดการบัญชีธนาคารพนักงาน" />
      </Tabs>

      {/* TAB 0: Monthly Grid */}
      {activeTab === 0 && (
        <Card variant="outlined">
          <CardContent style={{ padding: 0 }}>
            {loading ? (
              <Box py={8} textAlign="center">
                <CircularProgress />
                <Typography style={{ marginTop: 12 }}>กำลังโหลดข้อมูลเงินเดือนประจำเดือน...</Typography>
              </Box>
            ) : (
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableHeader} width={50} align="center">
                        ลำดับ
                      </TableCell>
                      <TableCell className={classes.tableHeader} width={250}>ชื่อ - สกุล</TableCell>
                      <TableCell className={classes.tableHeader}>ตำแหน่ง / กลุ่ม</TableCell>
                      <TableCell className={classes.tableHeader}>ธนาคาร / เลขบัญชี</TableCell>
                      <TableCell className={classes.tableHeader} align="right">
                        รวมรายได้ (บาท)
                      </TableCell>
                      <TableCell className={classes.tableHeader} align="right">
                        รวมรายการหัก (บาท)
                      </TableCell>
                      <TableCell className={classes.tableHeader} align="right">
                        เงินเดือนสุทธิ (บาท)
                      </TableCell>
                      <TableCell className={classes.tableHeader} align="center" width={110}>
                        สถานะ
                      </TableCell>
                      <TableCell className={classes.tableHeader} align="center" width={170}>
                        จัดการ
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredItems.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center" style={{ padding: 32 }}>
                          ไม่พบข้อมูลเงินเดือนในเดือนนี้
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredItems.map((row, idx) => (
                        <TableRow key={row.userName} className={classes.tableRow}>
                          <TableCell align="center">{idx + 1}</TableCell>
                          <TableCell style={{ fontWeight: "bold" }}>
                            <div onClick={() => {
                                  setSelectedUserForDetail(row.userName);
                                  setDetailModalOpen(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {row.fullName}
                            </div>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">{row.positionName || "-"}</Typography>
                            <Chip
                              label={row.typeGovName || "-"}
                              size="small"
                              variant="outlined"
                              style={{ fontSize: 11 }}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="caption" display="block" style={{ fontWeight: "bold" }}>
                              {row.bankName || "-"}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {row.accountNo || "-"}
                            </Typography>
                          </TableCell>
                          <TableCell align="right" style={{ color: "#2e7d32", fontWeight: "bold" }}>
                            {row.totalIncome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                          </TableCell>
                          <TableCell align="right" style={{ color: "#c62828", fontWeight: "bold" }}>
                            {row.totalOutcome.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                          </TableCell>
                          <TableCell align="right" style={{ color: "#0d47a1", fontWeight: "bold", fontSize: "1rem" }}>
                            {row.netSalary.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                          </TableCell>
                          <TableCell align="center">
                            {row.approve === "y" ? (
                              <Chip
                                label="อนุมัติแล้ว"
                                size="small"
                                style={{ backgroundColor: "#e8f5e9", color: "#2e7d32", fontWeight: "bold" }}
                              />
                            ) : (
                              <Chip
                                label="รออนุมัติ"
                                size="small"
                                style={{ backgroundColor: "#ffebee", color: "#c62828", fontWeight: "bold" }}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Box display="flex" justifyContent="center" gap={0.5}>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<EditIcon style={{ fontSize: 16 }} />}
                                onClick={() => {
                                  setSelectedUserForDetail(row.userName);
                                  setDetailModalOpen(true);
                                }}
                              >
                                บันทึก
                              </Button>
                              
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </CardContent>
        </Card>
      )}

      {/* TAB 1: Batch In/Out Category */}
      {activeTab === 1 && (
        <SalaryBatchCategoryManager
          calYear={calYear}
          calMonth={calMonth}
          incomes={incomes}
          outcomes={outcomes}
          typeGovList={typeGovList}
        />
      )}

      {/* TAB 2: Employee Bank Accounts */}
      {activeTab === 2 && (
        <SalaryEmployeeManager
          banks={banks}
          typeGovList={typeGovList}
          onEmployeeChanged={loadMonthlySummary}
        />
      )}

      {/* Detail Modal */}
      {detailModalOpen && (
        <SalaryPersonDetailModal
          open={detailModalOpen}
          userName={selectedUserForDetail}
          calYear={calYear}
          calMonth={calMonth}
          onClose={() => setDetailModalOpen(false)}
          onSaved={loadMonthlySummary}
        />
      )}

      {/* Slip Dialog */}
      {slipDialogOpen && (
        <SalarySlipDialog
          open={slipDialogOpen}
          userName={selectedUserForSlip}
          calYear={calYear}
          calMonth={calMonth}
          onClose={() => setSlipDialogOpen(false)}
        />
      )}

      {/* Rollover Dialog */}
      <Dialog
        open={rolloverDialogOpen}
        onClose={() => setRolloverDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: "#00796b", color: "#fff" }}>
          ยกยอดเงินเดือนไปเดือนถัดไป (Rollover)
        </DialogTitle>
        <DialogContent dividers>
          <Box py={1}>
            <Typography variant="body2" gutterBottom>
              ระบบจะคัดลอกรายการได้และรายการหักของพนักงานทุกคนจากเดือนปัจจุบันไปยังเดือนเป้าหมาย:
            </Typography>
            <Box p={1.5} my={2} bgcolor="#e0f2f1" borderRadius={4}>
              <Typography variant="body2">
                <strong>ต้นทาง:</strong> ประจำเดือน {calMonth} พ.ศ. {calYear}
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="ปีเป้าหมาย"
                  value={targetYear}
                  onChange={e => setTargetYear(Number(e.target.value))}
                >
                  {years.map(y => (
                    <MenuItem key={y} value={y}>
                      พ.ศ. {y}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="เดือนเป้าหมาย"
                  value={targetMonth}
                  onChange={e => setTargetMonth(Number(e.target.value))}
                >
                  {thaiMonths.map(m => (
                    <MenuItem key={m.val} value={m.val}>
                      {m.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRolloverDialogOpen(false)}>ยกเลิก</Button>
          <Button
            onClick={handleRollover}
            color="primary"
            variant="contained"
            disabled={rollingOver}
          >
            {rollingOver ? "กำลังยกยอด..." : "ยืนยันการยกยอด"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

